<script setup lang="ts">
import BaseModalCloseButton from '@/components/base/BaseModalCloseButton.vue'

defineProps<{
    hideClose?: boolean
}>()

const emit = defineEmits<{
    close: [void]
}>()
</script>

<template>
    <header class="flex items-center justify-between">
        <div class="flex items-center">
            <slot />
        </div>

        <div
            aria-label="Close Modal"
            class="flex items-center">
            <BaseModalCloseButton
                v-if="!hideClose"
                @close="emit(`close`)" />

            <slot name="end" />
        </div>
    </header>
</template>
